import { Helmet } from 'react-helmet';

const SEO = ({
  title = "Profixer Door Services - Garage Door Repair Calgary & Area | 24/7 Emergency Service",
  description = "Expert garage door repair & installation in Calgary, Airdrie, Cochrane & surrounding areas. 24/7 emergency service, same-day repairs, free quotes. Spring repair, cable & track, opener services & more.",
  keywords = "garage door repair Calgary, garage door installation Calgary, emergency garage door repair, garage door spring repair, garage door opener installation, 24/7 garage door service, Calgary garage door, garage door service Calgary AB",
  image = "/logo192.png",
  url = "https://profixer.ca",
  type = "website",
  structuredData = null,
  breadcrumbs = null
}) => {
  const siteName = "Profixer Door Services";
  const twitterHandle = "@profixerdoors";

  // Comprehensive structured data for local SEO
  const defaultStructuredData = [
    // LocalBusiness Schema
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://profixer.ca/#organization",
      "name": "Profixer Door Services",
      "alternateName": "Profixer Garage Door Services",
      "description": "Professional garage door repair, installation, and maintenance services in Calgary and surrounding areas. 24/7 emergency service available.",
      "url": "https://profixer.ca",
      "telephone": "+1-403-690-7147",
      "email": "info@profixer.ca",
      "foundingDate": "2016",
      "priceRange": "$$",
      "paymentAccepted": ["Cash", "Credit Card", "Check"],
      "currenciesAccepted": "CAD",

      // Address
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Calgary",
        "addressRegion": "AB",
        "addressCountry": "CA",
        "postalCode": "T2P"
      },

      // Geographic information
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "51.0447",
        "longitude": "-114.0719"
      },

      // Service areas with detailed coverage
      "areaServed": [
        {
          "@type": "City",
          "name": "Calgary",
          "addressRegion": "AB",
          "addressCountry": "CA"
        },
        {
          "@type": "City",
          "name": "Airdrie",
          "addressRegion": "AB",
          "addressCountry": "CA"
        },
        {
          "@type": "City",
          "name": "Cochrane",
          "addressRegion": "AB",
          "addressCountry": "CA"
        },
        {
          "@type": "City",
          "name": "Chestermere",
          "addressRegion": "AB",
          "addressCountry": "CA"
        },
        {
          "@type": "City",
          "name": "Okotoks",
          "addressRegion": "AB",
          "addressCountry": "CA"
        }
      ],

      // Operating hours
      "openingHours": [
        "Mo-Su 00:00-23:59"
      ],
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          "opens": "00:00",
          "closes": "23:59",
          "description": "24/7 Emergency Service Available"
        }
      ],

      // Services offered
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Garage Door Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Garage Door Spring Repair",
              "description": "Professional repair and replacement of broken garage door springs. Torsion and extension springs.",
              "serviceType": "Repair",
              "areaServed": "Calgary AB"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Garage Door Cable & Track Repair",
              "description": "Expert repair of garage door cables, tracks, and rollers. Bent track straightening and alignment.",
              "serviceType": "Repair",
              "areaServed": "Calgary AB"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Garage Door Opener Installation & Repair",
              "description": "Complete garage door opener services including installation, repair, programming, and Wi-Fi setup.",
              "serviceType": "Installation & Repair",
              "areaServed": "Calgary AB"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Emergency Garage Door Repair",
              "description": "24/7 emergency garage door repair service. Same-day response for stuck or broken doors.",
              "serviceType": "Emergency Repair",
              "areaServed": "Calgary AB",
              "availableChannel": {
                "@type": "ServiceChannel",
                "availableLanguage": "English",
                "serviceUrl": "tel:+1-403-690-7147"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Garage Door Installation",
              "description": "Professional installation of new garage doors. All brands and types supported.",
              "serviceType": "Installation",
              "areaServed": "Calgary AB"
            }
          }
        ]
      },

      // Reviews and ratings
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5.0",
        "reviewCount": "500",
        "bestRating": "5",
        "worstRating": "1"
      },

      // Reviews
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Calgary Homeowner"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "datePublished": "2025-11-15",
          "reviewBody": "Fast, professional service. They fixed our broken spring in under an hour. Highly recommend!"
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Airdrie Customer"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "datePublished": "2025-12-03",
          "reviewBody": "Same-day service, upfront pricing, and excellent workmanship. Our garage door works perfectly now."
        }
      ],

      // Social media
      "sameAs": [
        "https://www.facebook.com/profixerdoors",
        "https://twitter.com/profixerdoors"
      ]
    },

    // Organization Schema
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "https://profixer.ca/#organization",
      "name": "Profixer Door Services",
      "url": "https://profixer.ca",
      "logo": "https://profixer.ca/logo192.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+1-403-690-7147",
        "contactType": "Customer Service",
        "availableLanguage": "English",
        "contactOption": "TollFree"
      },
      "sameAs": [
        "https://www.facebook.com/profixerdoors",
        "https://twitter.com/profixerdoors"
      ]
    },

    // FAQ Schema for common questions
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "How quickly can you respond to garage door emergencies?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer 24/7 emergency garage door repair service with an average response time of 2 hours or less in the Calgary area."
          }
        },
        {
          "@type": "Question",
          "name": "Do you provide free estimates for garage door repairs?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we provide free, upfront pricing for all garage door repair and installation services. No hidden fees or surprise costs."
          }
        },
        {
          "@type": "Question",
          "name": "What areas do you service in Calgary?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We proudly serve all Calgary quadrants (NW, NE, SW, SE) plus surrounding communities including Airdrie, Cochrane, Chestermere, Okotoks, and rural areas within 50km of Calgary."
          }
        },
        {
          "@type": "Question",
          "name": "How long does garage door spring repair take?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most garage door spring repairs can be completed in 1-2 hours. Emergency repairs for stuck doors are usually resolved within 30-60 minutes."
          }
        },
        {
          "@type": "Question",
          "name": "Do you work on all garage door brands?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we service all major garage door brands including Clopay, Wayne Dalton, Overhead Door, Chamberlain, LiftMaster, Genie, and more. We work with all types of openers and door systems."
          }
        }
      ]
    },

    // WebSite Schema for site search
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": "https://profixer.ca/#website",
      "url": "https://profixer.ca",
      "name": "Profixer Door Services",
      "description": "Professional garage door repair and installation services in Calgary AB",
      "publisher": {
        "@id": "https://profixer.ca/#organization"
      },
      "inLanguage": "en-CA"
    }
  ];

  // Add BreadcrumbList if breadcrumbs provided
  const breadcrumbSchema = breadcrumbs ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": crumb.url
    }))
  } : null;

  const finalStructuredData = structuredData || [
    ...defaultStructuredData,
    ...(breadcrumbSchema ? [breadcrumbSchema] : [])
  ];

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_CA" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content={twitterHandle} />

      {/* Additional SEO meta tags */}
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="bingbot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="author" content="Profixer Door Services" />
      <meta name="language" content="English" />
      <meta name="geo.region" content="CA-AB" />
      <meta name="geo.placename" content="Calgary" />
      <meta name="geo.position" content="51.0447;-114.0719" />
      <meta name="ICBM" content="51.0447, -114.0719" />
      <meta name="rating" content="general" />
      <meta name="distribution" content="global" />

      {/* Business-specific meta tags */}
      <meta name="business:contact_data:street_address" content="Calgary, AB, Canada" />
      <meta name="business:contact_data:locality" content="Calgary" />
      <meta name="business:contact_data:region" content="AB" />
      <meta name="business:contact_data:postal_code" content="T2P" />
      <meta name="business:contact_data:country_name" content="Canada" />
      <meta name="business:contact_data:phone_number" content="+1-403-690-7147" />

      {/* Service-specific meta tags */}
      <meta name="service:area" content="Calgary, Airdrie, Cochrane, Chestermere, Okotoks" />
      <meta name="service:type" content="Garage Door Repair, Installation, Maintenance" />

      {/* Mobile optimization */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#0a4e99" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />

      {/* Google Search Console Verification - Add your verification code here */}
      {/* <meta name="google-site-verification" content="your-google-verification-code-here" /> */}

      {/* Bing Webmaster Tools Verification - Add your verification code here */}
      {/* <meta name="msvalidate.01" content="your-bing-verification-code-here" /> */}

      {/* Yandex Webmaster Verification - Add your verification code here */}
      {/* <meta name="yandex-verification" content="your-yandex-verification-code-here" /> */}

      {/* Additional SEO enhancements */}
      <meta name="referrer" content="strict-origin-when-cross-origin" />
      <meta name="format-detection" content="telephone=yes" />
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.googleapis.com" crossorigin />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />

      {/* Performance optimizations */}
      <link rel="preload" href="/logo192.png" as="image" />
      <link rel="preload" href="/favicon.ico" as="image" />
      
      {/* Alternate links for language/region */}
      <link rel="alternate" hreflang="en-ca" href={url} />
      <link rel="alternate" hreflang="en" href={url} />
      <link rel="alternate" hreflang="x-default" href={url} />

      {/* Structured Data - Multiple schemas */}
      {Array.isArray(finalStructuredData) ? (
        finalStructuredData.map((data, index) => (
          <script key={index} type="application/ld+json">
            {JSON.stringify(data)}
          </script>
        ))
      ) : (
        <script type="application/ld+json">
          {JSON.stringify(finalStructuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;